import { clerkMiddleware } from "@clerk/tanstack-react-start/server";
import { createCsrfMiddleware, createStart } from "@tanstack/react-start";

import { evlogServerFnErrorMiddleware } from "./server/middleware/evlogServerFnError";
import { requestContextMiddleware } from "./server/middleware/requestContext";
import { serverFnLogMiddleware } from "./server/middleware/serverFnLogMiddleware";

const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === "serverFn",
});

export const startInstance = createStart(() => {
  return {
    requestMiddleware: [requestContextMiddleware, csrfMiddleware, clerkMiddleware()],
    functionMiddleware: [serverFnLogMiddleware, evlogServerFnErrorMiddleware],
  };
});
